import React, { useState } from "react";

import $ from "jquery";
import { toast } from "react-hot-toast";
import { Card, Col, Form, Row } from "react-bootstrap";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import {
      FormButton,
      FormImage,
      FormInput,
      FormSelect,
      FormStatusSelect,
} from "../../components/form";
import { privateApi } from "../../api";

const designs = [
      {
            title: "Left Banner Design",
            id: "Left Banner Design",
      },
      {
            title: "Middle Banner Design",
            id: "Middle Banner Design",
      },
      {
            title: "Bottom Banner Design",
            id: "Bottom Banner Design",
      },
      {
            title: "Side Offer Banner",
            id: "Side Offer Banner",
      },
      {
            title: "Middle Offer Banner",
            id: "Middle Offer Banner",
      },
];

const BannerCreate = () => {
      const [title, setTitle] = useState("");
      const [link, setLink] = useState("");
      const [design, setDesign] = useState("");
      const [image, setImage] = useState("");
      const [imageUrl, setImageUrl] = useState("");
      const [status, setStatus] = useState("");
      const [loading, setLoading] = useState(false);

      const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            const data = {
                  title: title,
                  link: link,
                  design: design,
                  image: image,
                  status: status,
            };
            await privateApi
                  .post(`/dashboard/banners`, data)
                  .then((response) => {
                        if (response.data.result === "success") {
                              toast.success(response.data.message);
                              $("form").trigger("reset");
                              setImageUrl("");
                        }
                        if (response.data.result === "error") {
                              if (response.data.message.title) {
                                    toast.error(response.data.message.title);
                              }
                              if (response.data.message.image) {
                                    toast.error(response.data.message.image);
                              }
                              if (response.data.message.status) {
                                    toast.error(response.data.message.status);
                              }
                        }
                  })
                  .catch((error) => {
                        toast.error(error.message);
                  });
            setLoading(false);
      };

      return (
            <>
                  <Form onSubmit={handleFormSubmit}>
                        <Row>
                              <Col lg={12}>
                                    <Card>
                                          <CardHeader title="Create New Banner">
                                                <LinkButton
                                                      link="/dashboard/banners"
                                                      title="Back"
                                                />
                                          </CardHeader>
                                          <Card.Body>
                                                <Row className="g-3">
                                                      <FormInput
                                                            title="Title"
                                                            required={true}
                                                            classes={8}
                                                            handleChange={
                                                                  setTitle
                                                            }
                                                      />
                                                      <FormSelect
                                                            title="Design"
                                                            options={designs}
                                                            setData={setDesign}
                                                            required={true}
                                                            classes={4}
                                                      />
                                                      <FormInput
                                                            title="Link"
                                                            required={false}
                                                            classes={4}
                                                            handleChange={
                                                                  setLink
                                                            }
                                                      />
                                                      <FormStatusSelect
                                                            title="Status"
                                                            classes={4}
                                                            setStatus={
                                                                  setStatus
                                                            }
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4">
                                          <Card.Body>
                                                <Row>
                                                      <FormImage
                                                            title="Featured Image"
                                                            setImage={setImage}
                                                            setImageUrl={
                                                                  setImageUrl
                                                            }
                                                            required={true}
                                                            imageUrl={imageUrl}
                                                      />
                                                </Row>
                                          </Card.Body>
                                    </Card>

                                    <Card className="mt-4 mb-5">
                                          <Card.Body>
                                                <Col lg={12}>
                                                      <FormButton
                                                            title="Submit"
                                                            loading={loading}
                                                      />
                                                </Col>
                                          </Card.Body>
                                    </Card>
                              </Col>
                        </Row>
                  </Form>
            </>
      );
};

export default BannerCreate;
